import clsx from 'clsx'
import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { SiteTakeoverCampaignTagLabel } from './SiteTakeoverCampaignTagLabel'
import { useSiteTakeoverTheme } from '../hooks/useSiteTakeoverTheme'
import { rem } from 'polished'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { getNavigationMenuIcon } from 'content/components/Icon/utils'
import { useSiteTakeoverCampaignUIState } from '../hooks/useSiteTakeoverCampaignUIState'

const Container = styled.div`
  display: grid;
  --sheet-border-width: 1px;
  grid-template-columns: [border-start] var(--sheet-border-width) [content-start] minmax(0px, 1fr) [content-end] var(--sheet-border-width) [border-end];
  grid-template-rows:
    [label-start]
    auto
    [border-start]
    var(--sheet-border-width)
    auto
    [label-end content-start]
    minmax(0px, 1fr)
    [content-end]
    var(--sheet-border-width)
    [border-end];
`

const LabelContainer = styled.div`
  grid-column: border;
  grid-row: label;

  &.placement-start { justify-self: start; }
  &.placement-center { justify-self: center; }
  &.placement-end { justify-self: end; }
`

const Border = styled.div`
  grid-column: border;
  grid-row: border;
  pointer-events: none;
  border-width: var(--sheet-border-width);
  border-style: solid;
  border-radius: 2px;
  border-width: 1px;
`

const Content = styled.div`
  grid-column: content;
  grid-row: content;
  padding: ${rem(28)} ${rem(20)} ${rem(20)} ${rem(20)};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${rem(4)};
  align-self: stretch;
`
interface Props {
  campaignTagId: string
}

export const SiteTakeoverCampaignUSP = forwardRef<HTMLDivElement, Props>((
  props,
  ref,
) => {
  const { campaignTagId } = props
  // fetch the theme from sitetakeover
  const siteTakeoverTheme = useSiteTakeoverTheme()

  const {
    shouldShowUSP,
    uspPayload,
  } = useSiteTakeoverCampaignUIState({
    campaignTagId,
  })

  if (!shouldShowUSP || !uspPayload?.uspItems?.length) {
    return null
  }

  const uspItems = uspPayload?.uspItems

  return <Container ref={ref}>
    <Border
      aria-hidden="true"
      style={{
        borderColor: siteTakeoverTheme?.labelStyle,
        borderImage: `${siteTakeoverTheme?.labelStyle} 1`,
      }}
    />
    <LabelContainer className={clsx('placement-start')}>
      <SiteTakeoverCampaignTagLabel campaignTagId={campaignTagId} forcedVisible onOfferCard />
    </LabelContainer>
    <Content>
      {uspItems.map(usp => {
        const IconComponent = getNavigationMenuIcon(usp.icon)
        return (
          <BodyTextBlock
            variant="medium"
            startIcon={IconComponent ? <IconComponent /> : undefined}
            key={usp.description}
          >
            {usp.description}
          </BodyTextBlock>
        )
      })}
    </Content>
  </Container>
})
